<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">EXECUTE TRADE</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form  @submit.prevent="">
                <div class="form-row">
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Price</label>
                        <input 
                            type="number" 
                            class="form-control" 
                            id="inputLast" 
                            :disabled="isOperator"
                            v-model="price"
                        >
                    </div>
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Executed At (EST)</label>
                        <datetime :disabled-dates="disabledDatesBought" format="MM/DD/YYYY H:i:s" width="100%" v-model="exeTime" placeholder="MM/DD/YYYY h:i:s"></datetime>
                    </div>
                </div> 
                <!-- <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputLast">Yield</label>
                        <input 
                            type="number" 
                            class="form-control" 
                            id="inputLast" 
                            v-model="exeYield"
                        >
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputLast">Interest</label>
                         <input 
                            type="number" 
                            class="form-control" 
                            id="inputLast" 
                            v-model="exeInterest"
                        >
                    </div>
                </div>  -->
                <div class="form-row" v-if="isOperator">
                    <div class="form-group col-md-12">
                        <label for="inputLast">Note</label>
                        <textarea :disabled="true" style="height:auto" class="form-control" v-model="holding.note" rows="6"></textarea>
                    
                    </div>
                </div>       
            </form>   
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
            <div class="modal-footer bid">
                <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                <button  type="button" @click="execute()" class="btn btn-success" >EXECUTE</button>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import datetime from 'vuejs-datetimepicker';
import config from "@/config";
import authService from "@/authService";
import moment_timezone from 'moment-timezone'
export default {
    name: 'execute',
    props:['holding','isOperator'],
    components :{
       datetime
    },
    data() {
        return {
           disabledDatesBought: {
                from : new Date()
            },
            exeInterest : 0,
            exeYield : 0,
            exeTime : "",
            price : 0,
            ecn : "",
            highBidId : 0,
            loading : false,
            highBidPrice : null

        }

    },
    methods:{
        execute(){
            var dateObj     = this.moment.tz(this.exeTime,'MM/DD/YYYY HH:mm:ss', "America/New_York");
            var convertTimeInUTC = dateObj.utc().format("MM/DD/YYYY HH:mm:ss");
            let dataToSend = {
                                "bidWantedBidId": this.highBidId,
                                "ecn": this.ecn,
                                "price": this.price,
                                // "exeInterest": this.exeInterest,
                                // "exeYield": this.exeYield,
                                "exeTime": convertTimeInUTC,
                                "cognitoSub": authService.getUser().cognitoSub
                            }
            if(!this.price){
                this.$alert("Price is required","","error");
                return ;
            }   
            if(!this.exeTime){
                this.$alert("Executed Time is required","","error");
                return ;
            }  
            // if(!this.exeYield){
            //     this.$alert("Yield is required","","error");
            //     return ;
            // }  
            // if(!this.exeInterest){
            //     this.$alert("Interest is required","","error");
            //     return ;
            // }  
            var message = `Are you sure you want to bring in?`;

            var difference = Math.abs(Number(this.highBidPrice) - Number(this.price));
            if (difference > 2) {
                message = "The entered price varies by more than 2 points from the high bid price. Would you like to proceed?"
            }

            this.$confirm(message,"","question",{confirmButtonText:"BRING IN",cancelButtonText : "NO"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: {'org-token' : authService.getOrgToken() }
                };
                this.$http
                    .post(
                    config.baseUrlBidSide +
                        "/bidwanted/execute",dataToSend,
                        auth
                    )
                    .then(() => {
                        this.loading = false;
                        this.$alert("Executed successfully ","","success");
                        this.$emit('close');
                    })
                    .catch(e => {
                        console.log(e);
                        this.loading = false;
                        
                    });
                });
        },
    },
    mounted(){
        this.exeTime = moment_timezone().tz('America/New_York').format("MM/DD/YYYY HH:mm:ss")
        this.holding.bidWantedBids.forEach(bid => {
           // if(bid.highBid){
                this.ecn = bid.ecn;
                this.price =  this.holding.bringInPrice ? this.holding.bringInPrice: bid.bidPrice;
                this.highBidId = bid.id
                this.highBidPrice = this.holding.bringInPrice ? this.holding.bringInPrice: bid.bidPrice;

           // }
        });
        // this.price =  this.holding.bringInPrice ? this.holding.bringInPrice : this.holding.highBidPrice;
        // this.highBidId = this.holding.highBidId;
        // this.ecn = this.holding.highBidEcn;

    }
};
</script>